/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Dec 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import constants from '../../../../globalization';
import Button from '../../../../components/Button';
import PopupHeader from '../PopupHeader';
import Voucher from './Voucher';
import styles from './Redeem.module.css';

const RedeemSearchedVoucher = props => {
  const { searchedVoucher, currency, iso2, closePopup, redeemVoucher } = props;
  const { checkHeader: check, message } = searchedVoucher || {};
  const { vouchers } = check || {};
  const voucher0 = (Array.isArray(vouchers) && vouchers.length) ? vouchers[0] : {};
  const { status } = voucher0 || {};

  return (
    <div className={styles.container}>
      <PopupHeader containerStyle={styles.headerWrapper} onClose={closePopup} />
      <Voucher
        check={check}
        currency={currency}
        iso2={iso2}
        message={message}
      >
        <Button
          className={styles.button}
          disabled={status !== 0}
          onClick={redeemVoucher}
        >
          <span className={styles.btnText}>{constants.redeemVoucher}</span>
        </Button>
      </Voucher>
    </div>
  );
};

export default RedeemSearchedVoucher;

RedeemSearchedVoucher.propTypes = {
  searchedVoucher: PropTypes.object.isRequired,
  currency: PropTypes.string,
  iso2: PropTypes.string,
  closePopup: PropTypes.func.isRequired,
  redeemVoucher: PropTypes.func.isRequired,
};

RedeemSearchedVoucher.defaultProps = {
  searchedVoucher: {},
  currency: '$',
  iso2: 'US',
  closePopup: () => { },
  redeemVoucher: () => { },
};
